import styled from 'styled-components';
import { FontFamilyRegular, FontSize14 } from '../fonts';

export const TextInputHelperText = styled.p`
    ${FontFamilyRegular};
    ${FontSize14};
    color: ${props => props.theme.color.darkBlue};
    background-color: transparent;
    margin: 0;
    padding: 0;
    border: none;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background-color: ${props => props.theme.color.black};
    };
`;